var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 646,
    height: 382,
    viewBox: "0 0 646 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.527 16.617c-241 6.62-229.964-40.5-340 0s-176.055 207-91.055 292 260 90 455 43 217.055-341.62-23.945-335z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/bg.f3e30482ef157f1b4f1f00462a7e9f7f.svg";
export { SvgBg as ReactComponent };